"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQuoteItemStore = exports.supportsInteractivePricing = exports.QuoteProductItemStore = exports.QuoteVariableItemStore = exports.QuoteFixedCostItemStore = exports.QuotePricedItemStore = exports.QuoteTextItemStore = void 0;
var ListItem_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgets/ListItem");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var UniqueId_1 = __importDefault(require("@CommonFrontendBackend/Utils/UniqueId"));
var Text_1 = require("ContentTokens/DataModels/Text");
var Types_2 = require("ContentTokens/Models/inputs/Types");
var Token_1 = require("ContentTokens/Token");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var CalculateItem_1 = require("QuoteV2/Calculator/CalculateItem");
var DiscountStore_1 = __importStar(require("./DiscountStore"));
var BaseQuoteItemStore = (function () {
    function BaseQuoteItemStore(_angularItem) {
        var _a;
        this._id = (_a = _angularItem.$id) !== null && _a !== void 0 ? _a : (0, UniqueId_1.default)();
        this._angularItem = (0, lodash_1.cloneDeep)(_angularItem);
    }
    Object.defineProperty(BaseQuoteItemStore.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseQuoteItemStore.prototype, "angularModel", {
        get: function () {
            return __assign({ $id: this._id }, this._angularItem);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseQuoteItemStore.prototype, "description", {
        get: function () {
            return this._angularItem.description;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], BaseQuoteItemStore.prototype, "_angularItem", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseQuoteItemStore.prototype, "angularModel", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof Token_1.IContentModel !== "undefined" && Token_1.IContentModel) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], BaseQuoteItemStore.prototype, "description", null);
    return BaseQuoteItemStore;
}());
var QuoteTextItemStore = (function (_super) {
    __extends(QuoteTextItemStore, _super);
    function QuoteTextItemStore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QuoteTextItemStore;
}(BaseQuoteItemStore));
exports.QuoteTextItemStore = QuoteTextItemStore;
var QuotePricedItemStore = (function (_super) {
    __extends(QuotePricedItemStore, _super);
    function QuotePricedItemStore(angularItem, currency, services) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var _this = _super.call(this, angularItem) || this;
        _this.currency = currency;
        _this.services = services;
        _this.setRecurringFrequency = function (recurringFrequency) {
            (0, mobx_1.runInAction)(function () {
                _this.services.billingScheduleOrchestrator.setRecurringFrequency(_this._angularItem, recurringFrequency);
            });
        };
        _this.setOneOffSchedule = function () {
            (0, mobx_1.runInAction)(function () {
                _this.services.billingScheduleOrchestrator.setOneOffBillingSchedule(_this._angularItem);
            });
        };
        _this._discount = new DiscountStore_1.default((_a = _this._angularItem.discount) !== null && _a !== void 0 ? _a : DiscountStore_1.defaultDiscount);
        _this._isOptional = (_c = (_b = angularItem.interactive) === null || _b === void 0 ? void 0 : _b.isOptional) !== null && _c !== void 0 ? _c : false;
        _this._isOptionalSelected = (_e = (_d = angularItem.interactive) === null || _d === void 0 ? void 0 : _d.isOptionalSelected) !== null && _e !== void 0 ? _e : false;
        _this._isQuantityOptional = (_g = (_f = angularItem.interactive) === null || _f === void 0 ? void 0 : _f.isQuantityOptional) !== null && _g !== void 0 ? _g : false;
        _this._quantityOptionalMin = (_j = (_h = angularItem.interactive) === null || _h === void 0 ? void 0 : _h.quantityRange.min) !== null && _j !== void 0 ? _j : 0;
        _this._quantityOptionalMax = (_l = (_k = angularItem.interactive) === null || _k === void 0 ? void 0 : _k.quantityRange.max) !== null && _l !== void 0 ? _l : 0;
        _this._isRecommended = angularItem.isRecommended;
        if (angularItem.featureList) {
            _this._featureList = angularItem.featureList;
            _this.shouldStoreFeatureList = true;
        }
        else {
            _this._featureList = {
                tokens: [(0, ListItem_1.createListItemToken)(), Text_1.text.createToken("")],
                content: "",
            };
            _this.shouldStoreFeatureList = false;
            var disposer_1 = (0, mobx_1.reaction)(function () { return JSON.stringify(_this.featureList); }, function () {
                _this.shouldStoreFeatureList = true;
                disposer_1();
            });
        }
        return _this;
    }
    Object.defineProperty(QuotePricedItemStore.prototype, "total", {
        get: function () {
            return this.services.calculatorService.calculateItem(this.angularModel, this.currency);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "quantity", {
        get: function () {
            var _a;
            return (_a = this._angularItem.quantity) !== null && _a !== void 0 ? _a : 0;
        },
        set: function (quantity) {
            if (this.isQuantityOptional) {
                if (quantity > this.quantityOptionalMax) {
                    this._angularItem.quantity = this.quantityOptionalMax;
                    return;
                }
                if (quantity < this.quantityOptionalMin) {
                    this._angularItem.quantity = this.quantityOptionalMin;
                    return;
                }
            }
            this._angularItem.quantity = quantity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "taxExempt", {
        get: function () {
            return this._angularItem.isTaxExempt;
        },
        set: function (taxExempt) {
            this._angularItem.isTaxExempt = taxExempt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "isRecommended", {
        get: function () {
            var _a;
            return (_a = this._isRecommended) !== null && _a !== void 0 ? _a : false;
        },
        set: function (isRecommended) {
            this._isRecommended = isRecommended;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "isOptional", {
        get: function () {
            return this._isOptional;
        },
        set: function (optional) {
            this._isOptional = optional;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "isOptionalSelected", {
        get: function () {
            return this._isOptionalSelected;
        },
        set: function (selected) {
            this._isOptionalSelected = selected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "isQuantityOptional", {
        get: function () {
            return this._isQuantityOptional;
        },
        set: function (optionalQuantity) {
            this._isQuantityOptional = optionalQuantity;
            if (optionalQuantity) {
                if (this.quantity < this.quantityOptionalMin) {
                    this.quantityOptionalMin = this.quantity;
                }
                if (this.quantity > this.quantityOptionalMax) {
                    this.quantityOptionalMax = this.quantity;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "quantityOptionalMin", {
        get: function () {
            return this._quantityOptionalMin;
        },
        set: function (min) {
            this._quantityOptionalMin = min;
            if (min > this.quantityOptionalMax) {
                this.quantityOptionalMax = min;
            }
            if (min > this.quantity) {
                this.quantity = min;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "quantityOptionalMax", {
        get: function () {
            return this._quantityOptionalMax;
        },
        set: function (max) {
            this._quantityOptionalMax = max;
            if (max < this.quantityOptionalMin) {
                this.quantityOptionalMin = max;
            }
            if (max < this.quantity) {
                this.quantity = max;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "discount", {
        get: function () {
            return this._discount;
        },
        set: function (discount) {
            this._discount = discount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "billingSchedule", {
        get: function () {
            return this.services.billingScheduleOrchestrator.getBillingSchedule(this._angularItem);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "featureList", {
        get: function () {
            return this._featureList;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuotePricedItemStore.prototype, "angularModel", {
        get: function () {
            return __assign(__assign(__assign(__assign({}, this._angularItem), { $id: this._id, discount: this.discount.angularModel, interactive: {
                    isOptional: this._isOptional,
                    isOptionalSelected: this._isOptionalSelected,
                    isQuantityOptional: this._isQuantityOptional,
                    quantityRange: {
                        min: this._quantityOptionalMin,
                        max: this._quantityOptionalMax,
                    },
                } }), (!(0, lodash_1.isUndefined)(this._isRecommended) ? { isRecommended: this._isRecommended } : {})), (this.shouldStoreFeatureList ? { featureList: this._featureList } : {}));
        },
        enumerable: false,
        configurable: true
    });
    var _b, _c, _d, _e, _f, _g, _h;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_b = typeof DiscountStore_1.default !== "undefined" && DiscountStore_1.default) === "function" ? _b : Object)
    ], QuotePricedItemStore.prototype, "_discount", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuotePricedItemStore.prototype, "_isOptional", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuotePricedItemStore.prototype, "_isOptionalSelected", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuotePricedItemStore.prototype, "_isQuantityOptional", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], QuotePricedItemStore.prototype, "_quantityOptionalMin", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], QuotePricedItemStore.prototype, "_quantityOptionalMax", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuotePricedItemStore.prototype, "_isRecommended", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_c = typeof Token_1.IContentModel !== "undefined" && Token_1.IContentModel) === "function" ? _c : Object)
    ], QuotePricedItemStore.prototype, "_featureList", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuotePricedItemStore.prototype, "shouldStoreFeatureList", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_d = typeof CalculateItem_1.CalculatedItem !== "undefined" && CalculateItem_1.CalculatedItem) === "function" ? _d : Object),
        __metadata("design:paramtypes", [])
    ], QuotePricedItemStore.prototype, "total", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], QuotePricedItemStore.prototype, "quantity", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuotePricedItemStore.prototype, "taxExempt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuotePricedItemStore.prototype, "isRecommended", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuotePricedItemStore.prototype, "isOptional", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuotePricedItemStore.prototype, "isOptionalSelected", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuotePricedItemStore.prototype, "isQuantityOptional", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], QuotePricedItemStore.prototype, "quantityOptionalMin", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], QuotePricedItemStore.prototype, "quantityOptionalMax", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_e = typeof DiscountStore_1.default !== "undefined" && DiscountStore_1.default) === "function" ? _e : Object),
        __metadata("design:paramtypes", [typeof (_f = typeof DiscountStore_1.default !== "undefined" && DiscountStore_1.default) === "function" ? _f : Object])
    ], QuotePricedItemStore.prototype, "discount", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_g = typeof Types_1.BillingSchedule !== "undefined" && Types_1.BillingSchedule) === "function" ? _g : Object),
        __metadata("design:paramtypes", [])
    ], QuotePricedItemStore.prototype, "billingSchedule", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_h = typeof Token_1.IContentModel !== "undefined" && Token_1.IContentModel) === "function" ? _h : Object),
        __metadata("design:paramtypes", [])
    ], QuotePricedItemStore.prototype, "featureList", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], QuotePricedItemStore.prototype, "angularModel", null);
    return QuotePricedItemStore;
}(BaseQuoteItemStore));
exports.QuotePricedItemStore = QuotePricedItemStore;
var QuoteFixedCostItemStore = (function (_super) {
    __extends(QuoteFixedCostItemStore, _super);
    function QuoteFixedCostItemStore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(QuoteFixedCostItemStore.prototype, "unit", {
        get: function () {
            return this._angularItem.rate.unit;
        },
        set: function (unit) {
            var _this = this;
            (0, mobx_1.runInAction)(function () {
                _this._angularItem.rate.unit = unit;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteFixedCostItemStore.prototype, "rate", {
        get: function () {
            return this._angularItem.rate.rate;
        },
        set: function (rate) {
            var _this = this;
            (0, mobx_1.runInAction)(function () {
                _this._angularItem.rate.rate = rate;
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], QuoteFixedCostItemStore.prototype, "unit", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], QuoteFixedCostItemStore.prototype, "rate", null);
    return QuoteFixedCostItemStore;
}(QuotePricedItemStore));
exports.QuoteFixedCostItemStore = QuoteFixedCostItemStore;
var QuoteVariableItemStore = (function (_super) {
    __extends(QuoteVariableItemStore, _super);
    function QuoteVariableItemStore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(QuoteVariableItemStore.prototype, "rate", {
        get: function () {
            var _a;
            var rate = this.angularModel.rate;
            if ((0, Types_1.isVariableRate)(rate)) {
                return (_a = rate.variableId) !== null && _a !== void 0 ? _a : null;
            }
            return null;
        },
        set: function (rate) {
            var _this = this;
            (0, mobx_1.runInAction)(function () {
                if (rate) {
                    _this._angularItem.rate = { variableId: rate };
                }
                else {
                    _this._angularItem.rate = {};
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteVariableItemStore.prototype, "unit", {
        get: function () {
            var _a, _b;
            var rate = this.angularModel.rate;
            if ((0, Types_1.isVariableRate)(rate)) {
                var variableId = rate.variableId;
                if (!!variableId) {
                    return (_b = (_a = this.services.variableStore.getVariable(variableId)) === null || _a === void 0 ? void 0 : _a.unitName) !== null && _b !== void 0 ? _b : null;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], QuoteVariableItemStore.prototype, "rate", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], QuoteVariableItemStore.prototype, "unit", null);
    return QuoteVariableItemStore;
}(QuotePricedItemStore));
exports.QuoteVariableItemStore = QuoteVariableItemStore;
var QuoteProductItemStore = (function (_super) {
    __extends(QuoteProductItemStore, _super);
    function QuoteProductItemStore(item) {
        var _this = _super.call(this, item) || this;
        if (_this._angularItem.featureList) {
            _this._featureList = _this._angularItem.featureList;
            _this.shouldStoreFeatureList = true;
        }
        else {
            _this._featureList = {
                tokens: [(0, ListItem_1.createListItemToken)(), Text_1.text.createToken("")],
                content: "",
            };
            _this.shouldStoreFeatureList = false;
            var disposer_2 = (0, mobx_1.reaction)(function () { return JSON.stringify(_this.featureList); }, function () {
                _this.shouldStoreFeatureList = true;
                disposer_2();
            });
        }
        return _this;
    }
    Object.defineProperty(QuoteProductItemStore.prototype, "taxExempt", {
        get: function () {
            return this._angularItem.isTaxExempt;
        },
        set: function (taxExempt) {
            this._angularItem.isTaxExempt = taxExempt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductItemStore.prototype, "isOptional", {
        get: function () {
            return this._angularItem.interactive.isOptional;
        },
        set: function (isOptional) {
            this._angularItem.interactive.isOptional = isOptional;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductItemStore.prototype, "isOptionalSelected", {
        get: function () {
            return this._angularItem.interactive.isOptionalSelected;
        },
        set: function (isOptionalSelected) {
            this._angularItem.interactive.isOptionalSelected = isOptionalSelected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductItemStore.prototype, "isQuantityOptional", {
        get: function () {
            return this._angularItem.interactive.isQuantityOptional;
        },
        set: function (isQuantityOptional) {
            this._angularItem.interactive.isQuantityOptional = isQuantityOptional;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductItemStore.prototype, "quantityOptionalMin", {
        get: function () {
            return this._angularItem.interactive.quantityRange.min;
        },
        set: function (min) {
            this._angularItem.interactive.quantityRange.min = min;
            if (min > this.quantityOptionalMax) {
                this.quantityOptionalMax = min;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductItemStore.prototype, "quantityOptionalMax", {
        get: function () {
            return this._angularItem.interactive.quantityRange.max;
        },
        set: function (max) {
            this._angularItem.interactive.quantityRange.max = max;
            if (max < this.quantityOptionalMin) {
                this.quantityOptionalMin = max;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductItemStore.prototype, "featureList", {
        get: function () {
            return this._featureList;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductItemStore.prototype, "angularModel", {
        get: function () {
            return __assign(__assign(__assign({}, this._angularItem), { $id: this._id }), (this.shouldStoreFeatureList ? { featureList: this._featureList } : {}));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductItemStore.prototype, "token", {
        get: function () {
            return this._angularItem.token;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductItemStore.prototype, "filter", {
        get: function () {
            return this._angularItem.filter;
        },
        set: function (filter) {
            this._angularItem.filter = filter;
        },
        enumerable: false,
        configurable: true
    });
    var _j, _k, _l, _m, _o, _p;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_j = typeof Token_1.IContentModel !== "undefined" && Token_1.IContentModel) === "function" ? _j : Object)
    ], QuoteProductItemStore.prototype, "_featureList", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], QuoteProductItemStore.prototype, "shouldStoreFeatureList", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteProductItemStore.prototype, "taxExempt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteProductItemStore.prototype, "isOptional", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteProductItemStore.prototype, "isOptionalSelected", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], QuoteProductItemStore.prototype, "isQuantityOptional", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], QuoteProductItemStore.prototype, "quantityOptionalMin", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], QuoteProductItemStore.prototype, "quantityOptionalMax", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_k = typeof Token_1.IContentModel !== "undefined" && Token_1.IContentModel) === "function" ? _k : Object),
        __metadata("design:paramtypes", [])
    ], QuoteProductItemStore.prototype, "featureList", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], QuoteProductItemStore.prototype, "angularModel", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_m = typeof Types_2.RepeatingTokenInput !== "undefined" && Types_2.RepeatingTokenInput) === "function" ? _m : Object),
        __metadata("design:paramtypes", [])
    ], QuoteProductItemStore.prototype, "token", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], QuoteProductItemStore.prototype, "filter", null);
    return QuoteProductItemStore;
}(BaseQuoteItemStore));
exports.QuoteProductItemStore = QuoteProductItemStore;
var supportsInteractivePricing = function (item) {
    return item instanceof QuotePricedItemStore || item instanceof QuoteProductItemStore;
};
exports.supportsInteractivePricing = supportsInteractivePricing;
var createQuoteItemStore = function (quoteItem, currency, services) {
    switch (quoteItem.type) {
        case Types_1.QuoteItemType.Text:
            return new QuoteTextItemStore(quoteItem);
        case Types_1.QuoteItemType.FixedCost:
            return new QuoteFixedCostItemStore(quoteItem, currency, services);
        case Types_1.QuoteItemType.Variable:
            return new QuoteVariableItemStore(quoteItem, currency, services);
        case Types_1.QuoteItemType.Product:
            return new QuoteProductItemStore(quoteItem);
        default:
            throw new Error("Unrecognised quote item type: ".concat(quoteItem));
    }
};
exports.createQuoteItemStore = createQuoteItemStore;
